var map = {
	"./ai-icon-old.png": 1630,
	"./ai-icon.png": 9921,
	"./arrow.png": 1202,
	"./buy-crypto.png": 3174,
	"./craft-icon-old.png": 8808,
	"./craft-icon.png": 4658,
	"./fund.png": 651,
	"./ing-icon-old.png": 6307,
	"./ing-icon.png": 6371,
	"./sign-up.png": 7394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6314;